export const Tabs = {
	TODAY: 0,
	HOURLY: 1,
	FIVEDAY: 2,
	TENDAY: 3,
	RADAR: 4
};

export const StorageNS = {
	PREFERENCES: 'sync-user-preferences'
};

export const Preferences = {
	TEMP_UNIT: 'temp-unit'
};

export const Errors = {
	NO_ALERT_DETAILS_FOUND: 901,
	NO_DETAIL_KEY_FOUND: 901
};

export const DEFAULT_TEMP_UNIT = 'f',
	DEFAULT_DAILY_FORECAST_NUM_DAYS = 10,
	DEFAULT_HOURLY_FORECAST_NUM_HOURS = 24,
	DEFAULT_FORECAST_DAYS = 5,
	NOON = 12;



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/constants/index.js